<div class="filter-status-badge" *ngIf="isVisible">
  <svg class="filter-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 40 40" fill="none">
    <circle cx="19.666" cy="19.6665" r="7.375" fill="#4779F5"/>
  </svg>
  <span class="badge-text">Filters Applied</span>
</div>